import { render, staticRenderFns } from "./ScrollCfg.vue?vue&type=template&id=fe83a4d4&scoped=true"
import script from "./ScrollCfg.vue?vue&type=script&lang=js"
export * from "./ScrollCfg.vue?vue&type=script&lang=js"
import style0 from "./ScrollCfg.vue?vue&type=style&index=0&id=fe83a4d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe83a4d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe83a4d4')) {
      api.createRecord('fe83a4d4', component.options)
    } else {
      api.reload('fe83a4d4', component.options)
    }
    module.hot.accept("./ScrollCfg.vue?vue&type=template&id=fe83a4d4&scoped=true", function () {
      api.rerender('fe83a4d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/ScrollCfg.vue"
export default component.exports